import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { FeatureIcon } from '@ui/components/FeatureIcon/FeatureIcon'
import { Modal } from '@ui/components/Modal'
import { ClockIcon } from '@ui/icons/Clock.icon'

export const PaymentDoneModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Body centered>
        <FeatureIcon size='lg' icon={ClockIcon} color='text-white' bg='surface-warning-high-em' />
        <Modal.Body.Title color='text-high-em'>{t('Payment Processing')}</Modal.Body.Title>
        <Modal.Body.Text>
          {t('Your payment is being processed. We will inform you via email')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
